export default function isObject(obj: any) {
    return obj !== null && typeof obj === 'object';
}